'use client'

import { VercelToolbar } from '@vercel/toolbar/next'
import { useSearchParams } from 'next/navigation'

import { isDev } from '../helpers'
import useIsEmployee from '../hooks/useIsEmployee'

export default function StaffToolbar() {
  const searchParams = useSearchParams()
  const isEmployee = useIsEmployee()

  const forceToolbar =
    searchParams.has('toolbar') && searchParams.get('toolbar') !== 'false'
  const forceHideToolbar =
    searchParams.has('toolbar') && searchParams.get('toolbar') === 'false'

  if (((isDev() || !isEmployee) && !forceToolbar) || forceHideToolbar) {
    return false
  }

  return <VercelToolbar />
}
